import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";

import styles from "./theming-messaging-template-preview.less";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";
import { resources } from "@constants/hardcoded-strings";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { LayoutTypes } from "@enums/layout-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { MessagingTemplateContentPreview } from "@containers/messaging-template-details/messaging-template-details-component/messaging-template-preview-container/messaging-template-content-preview/messaging-template-content-preview";

type MessagingTemplateContentPreviewProps = {
    state: FormattedMessagingTemplate;
    selectedLanguage: LocaleTypes;
    previewTemplatesOptions: Array<SelectOption>;
    selectedPreviewTemplateOption: SelectOption;
    handleSelectPreviewTemplateChange: (selectOption: SelectOption<string>) => void;
}

export const ThemingMessagingTemplatePreview = ({ state, selectedLanguage, previewTemplatesOptions, selectedPreviewTemplateOption, handleSelectPreviewTemplateChange }: MessagingTemplateContentPreviewProps) => {
    const messagingTemplateResources = resources.pages.verificationServiceDetails.tabs.theming.subTabs.messaging;


    return <div className={styles.messagingTemplatePreview}>
        <div className={styles.messagingTemplatePreviewConfiguration}>
            <span className={styles.previewConfigurationTitle}>{messagingTemplateResources.sections.preview.title.label}</span>
            <SelectFormGroup
                controlId={`theming-messaging-preview-template-select-input`}
                automationId={`theming-messaging-preview-template-select-input`}
                label={messagingTemplateResources.inputs.previewTemplate.label}
                ariaLabel={messagingTemplateResources.inputs.previewTemplate.label}
                disabled={false}
                isClearable={false}
                isRequired={false}
                isSearchable={false}
                layout={LayoutTypes.ROW}
                labelWidth={LabelWidthTypes.MEDIUM}
                onChange={handleSelectPreviewTemplateChange}
                options={previewTemplatesOptions}
                selectedOption={selectedPreviewTemplateOption}
            />

        </div>

        {state && <MessagingTemplateContentPreview
            state={state}
            selectedLanguage={selectedLanguage}
        />}
    </div>
}